export default __webpack_public_path__ + "static/media/ReportCenter.b0dc8f45.svg";